import { useMotionTuning } from "./lib/tuning.js";

/**
 * The ambient layer.
 *
 * The board prints a ghosted question mark into every unrevealed answer, so the
 * same mark drifting behind a screen is the game idling rather than decoration
 * borrowed from somewhere else. Four of them, on clocks that never line up.
 *
 * Purely decorative and `aria-hidden`; it also carries no pointer events, so it
 * can sit over any layout without taking a click. The host element needs to be
 * positioned and to clip its overflow — `.landing` and `.tv` both already are.
 */
export function DriftMarks() {
  const { markDrift_ms, markOpacity } = useMotionTuning().ambient;

  return (
    <div
      className="driftMarks"
      aria-hidden="true"
      style={{
        ["--drift-mark-ms" as string]: `${markDrift_ms}ms`,
        ["--drift-mark-opacity" as string]: markOpacity,
      }}
    >
      <span>?</span>
      <span>?</span>
      <span>?</span>
      <span>?</span>
    </div>
  );
}
